import React from "react";
import CommonWelcome from "../../components/common/Welcome";

const Welcome = () => {
  return <CommonWelcome />;
};

export default Welcome;
